import React, { useEffect } from 'react';

import Faq from '../../atoms/Faq';

import { useStore } from '../../../hooks/Store';
import { useRelations } from '../../../hooks/Relations';

function FaqList({ scrollToBottom }: any) {
    const { relations } = useRelations();
    const { store } = useStore();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(
        scrollToBottom,
        [relations]
    );

    if (store.disableFAQ) return null;

    return (
        <div id='stx-faq'>
            {
                relations.map((item) => <Faq key={item.id} {...item} />)
            }
        </div>
    );
}

export default FaqList;
